import { request, spUrl } from "utils";
import moment from "moment";

import { HAPLO_ETHICS_API} from "globals/constants";

const fetchData = id => {
	return request(spUrl(`${HAPLO_ETHICS_API}/${id}`))
		.then(result => result.allItems.map(ethics => {
			return {
				...ethics,
				expiryDate: ethics.expiryDate ? moment(ethics.expiryDate).format('YYYY-MM-DD') : null,
				approvalDate: ethics.approvalDate ? moment(ethics.approvalDate).format('YYYY-MM-DD'): null,
				applicationLead: ethics.applicationLead?.join()
			}
		}
	));
};

const Helper = {
	apiKey: "ethicsId",
	fetchData
}

export default Helper;